export const extractReplyContent = (reply: string) => {
    let formattedReply = reply
    const startTag1 = '<div class="gmail_quote gmail_quote_container">'
    const startIndex1 = formattedReply.indexOf(startTag1)

    if (startIndex1 !== -1) {
        formattedReply = formattedReply.slice(0, startIndex1)
    }

    const startTag2 = '<div class="gmail_quote">'
    const startIndex2 = formattedReply.indexOf(startTag2)

    if (startIndex2 !== -1) {
        formattedReply = formattedReply.slice(0, startIndex2)
    }

    return formattedReply
}
